<template>
  <div class="flex flex-col w-full">
    <Toast position="top-[48px]"></Toast>
    <div class="text-[2rem] leading-[2.5rem] font-black text-[#433D31] tracking-[-0.03em]">
      Reset Email
    </div>
    <div class="text-[1rem] leading-[1.5rem] text-[#433D31] font-semibold pt-[8px]">
      Enter your new email.
    </div>

    <div class="pt-[40px]">
      <TextInput
        v-model="email"
        class="w-full"
        label="Email"
        type="email"
        labelClasses="text-[#191817] text-[0.875rem] leading-[1.25rem] font-semibold pb-[4px]"
        placeholder="example@email.com"
        :error="emailError"
      />
    </div>

    <div class="text-[0.875rem] leading-[1.25rem] text-[#637083] mt-[8px]">
      You can use this email to login next time
    </div>

    <BottomButton
      text="Next"
      :disabled="loading || !canSave"
      @click="handleOnComplete(email)"
      class="my-[32px]"
    />
  </div>
</template>

<script>
import TextInput from '@/components/design/TextInput.vue';
import BottomButton from '@/components/common/BottomButton.vue';
import Toast from '@/components/common/Toast.vue';

export default {
  components: {
    TextInput,
    BottomButton,
    Toast,
  },
  data() {
    return {
      email: '',
      emailError: '',
      loading: false,
    };
  },
  computed: {
    canSave() {
      return this.email.length > 0;
    },
  },
  methods: {
    async handleOnComplete(value) {
      this.emailError = '';
      if (!this.validateEmail(value)) {
        this.emailError = 'This is an invalid email. Please re-enter a valid email address. ';
        return;
      }
      this.loading = true;
      try {
        await this.$store.dispatch('forgotCredentials/sendEmailOtp', this.email);
        this.$store.commit('forgotCredentials/setNewEmail', this.email);
        this.$emit('next');
      } catch (error) {
        this.$refs.otpInput.clearInput();
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    validateEmail(email) {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return regex.test(email);
    },
  },
};
</script>

<style scoped>
:deep(.border-\[\#B80A0A\]) {
  border-color: #ec4e20;
}
</style>
